import React, { SFC } from "react";
import { BugerlijkeStaatField } from "./types";
import { SubCheckboxField } from "./SubCheckboxField";
import { useExclusiveField } from "./useExclusiveField";

export interface Props {
  field: BugerlijkeStaatField;
  allPrimaryFieldNames: string[];
}

export const PrimaryCheckboxField: SFC<Props> = ({ field, allPrimaryFieldNames }) => {
  const { onChange, value } = useExclusiveField(field.name, allPrimaryFieldNames, true);
  return (
    <div className="bs1">
      <input className="bs1" type="checkbox" id={field.name} name={field.name} onChange={onChange} checked={!!value} />
      <label className="checkboxlabel" htmlFor={field.name}>
        {field.label}
      </label>
      {field.children &&
        field.children.map((child) => <SubCheckboxField key={child.name} parentField={field} field={child} />)}
    </div>
  );
};

PrimaryCheckboxField.displayName = "PrimaryField";
